import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ScoreDisplay = ({ score, totalAttempts, countriesGuessed, timer, badge }) => {
  const { t } = useLanguage();

  return (
    <div className="score-container">
      <div>{t('score')}: <span className="score">{score}/{totalAttempts}</span></div>
      <div>{t('time')}: {timer}</div>
      <div>{badge}</div>
      <div>{t('countries')}: <span className="score">{countriesGuessed}/47</span></div>
    </div>
  );
};

export default ScoreDisplay;